<div fxLayout="row" fxLayoutAlign="center center">
    <button mat-button type="button" (click)="onSetTheme('light-theme')" *ngIf="theme$ == 'light-theme'; else elseBlock" type="button"><mat-icon>wb_sunny</mat-icon></button>
    <ng-template #elseBlock>
        <button mat-button type="button" (click)="onSetTheme('dark-theme')" type="button"><mat-icon>dark_mode</mat-icon></button>
    </ng-template>
</div>